import React from "react";
import { TableHead, TableRow, TableCell } from "@mui/material";
import { TableSortLabel } from "@mui/material";
import { COLUMNS } from "./constants";
import { tableConfigAtom } from "../../atoms/servicesTable";
import { useAtom } from "jotai";

export const ServicesTableHead = () => {
    const [tableConfig, setTableConfig] = useAtom(tableConfigAtom);
    const {
        sort: { sortBy, direction }
    } = tableConfig;
    return (
        <TableHead>
            <TableRow>
                {COLUMNS.map(({ key, label, sortable }) => {
                    return (
                        <TableCell
                            key={key}
                            sx={{
                                textWrap: "auto",
                                "&:last-child": {
                                    padding: "7px 5px 7px 9px !important"
                                },
                                textAlign:
                                    key === "locations" || key === "capacity"
                                        ? "center"
                                        : key === "price"
                                        ? "right"
                                        : "left"
                            }}
                        >
                            {sortable ? (
                                <TableSortLabel
                                    active={sortBy === key}
                                    direction={direction?.toLowerCase()}
                                    onClick={() =>
                                        setTableConfig({
                                            ...tableConfig,
                                            sort: {
                                                sortBy: key,
                                                direction:
                                                    direction === "ASC"
                                                        ? "DESC"
                                                        : "ASC"
                                            }
                                        })
                                    }
                                >
                                    {label}
                                </TableSortLabel>
                            ) : (
                                label
                            )}
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
};
